export const receiptConstants = {
    // Add and editing receipt
    SAVING_RECEIPT_REQUEST: 'SAVING_RECEIPT_REQUEST',
    SAVING_RECEIPT_SUCCESS: 'SAVING_RECEIPT_SUCCESS',
    SAVING_RECEIPT_FAILURE: 'SAVING_RECEIPT_FAILURE',

    // Loading receipts
    LOAD_RECEIPTS_REQUEST: 'LOAD_RECEIPTS_REQUEST',
    LOAD_RECEIPTS_SUCCESS: 'LOAD_RECEIPTS_SUCCESS',
    LOAD_RECEIPTS_FAILURE: 'LOAD_RECEIPTS_FAILURE',

    // Delete receipt
    DELETE_RECEIPT_REQUEST: 'DELETE_RECEIPT_REQUEST',
    DELETE_RECEIPT_SUCCESS: 'DELETE_RECEIPT_SUCCESS',
    DELETE_RECEIPT_FAILURE: 'DELETE_RECEIPT_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/receipt.constants.js